module.exports = __webpack_public_path__ + "img/personalcenter.f55b3a62.png";